import React from 'react';
import { motion } from 'framer-motion';

export default function Features() {
  const features = [
    {
      title: "Shaded Ceremony Spaces",
      copy: "Exchange vows surrounded by mature trees, hillside views, and a naturally romantic outdoor setting."
    },
    {
      title: "Indoor Air-Conditioned Reception",
      copy: "Enjoy the beauty of an outdoor ceremony with the comfort of an indoor reception experience."
    },
    {
      title: "Historic Estate Atmosphere",
      copy: "Spanish Revival architecture, lush gardens, and timeless details create a wedding setting guests remember."
    }
  ];

  return (
    <section className="py-24 bg-ivory">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-3xl md:text-4xl text-olive mb-4">Why Summer at Padua Works</h3>
          <div className="w-12 h-[1px] bg-gold mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {features.map((feature, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              className="text-center px-4 relative"
            >
              <div className="w-8 h-8 rounded-full border border-gold/30 flex items-center justify-center mx-auto mb-6">
                <div className="w-1.5 h-1.5 bg-gold rounded-full"></div>
              </div>
              <h4 className="text-xl mb-4 text-olive">{feature.title}</h4>
              <p className="font-sans font-light leading-relaxed text-olive/80">
                {feature.copy}
              </p>
              
              {/* Divider lines between columns on desktop */}
              {index < 2 && (
                <div className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2 w-[1px] h-24 bg-olive/10"></div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}